<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent="" scrollable  max-width="450px">
                <v-card>
                    <v-card-title>{{ formTitle }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: auto;">
                        <br>
                        <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                        <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                        <v-form id="form_rfid_user" ref="form" v-model="valid" lazy-validation>
                        <!-- začetni datum -->
                        <v-menu
                            ref="start_date_menu"
                            :close-on-content-click="false"
                            v-model="start_date_menu"
                            :nudge-right="40"
                            :return-value.sync="restriction_start_date"
                            
                            transition="scale-transition"
                            offset-y
                            
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-on="on"
                                    v-model="restriction_start_date_formatted"
                                    label="Veljavnost od"
                                    append-icon="mdi-calendar-today"
                                    readonly
                                    clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker color="secondary" @input="startDateMenuSave(restriction_start_date)" v-model="restriction_start_date" no-title scrollable locale="sl-si">
                            </v-date-picker>
                        </v-menu>

                        <!-- končni datum -->
                        <v-menu
                            ref="end_date_menu"
                            :close-on-content-click="false"
                            v-model="end_date_menu"
                            :nudge-right="40"
                            :return-value.sync="restriction_end_date"
                            
                            transition="scale-transition"
                            offset-y
                            
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-on="on"
                                    v-model="restriction_end_date_formatted"
                                    label="Veljavnost do"
                                    append-icon="mdi-calendar"
                                    readonly
                                    clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker color="secondary" @input="endDateMenuSave(restriction_end_date)" v-model="restriction_end_date" no-title scrollable locale="sl-si">
                            </v-date-picker>
                        </v-menu>

                        <!--<v-select
                            v-model="selected_devices"
                            :items="devices"
                            label="Izberi parkirišče"
                            multiple
                            chips
                            clearable
                            deletable-chips
                            item-value="id"
                            item-text="description"
                            return-object
                            dense
                            no-data-text="Ni podatkov za prikaz"
                            required
                            :rules="[]"
                        ></v-select> -->

                        <v-text-field
                            v-model="name"
                            label="Naziv"
                            required
                            clearable
                            append-icon="mdi-pencil"
                            :rules="name_rules"
                        ></v-text-field>
                        <v-text-field
                            v-model="registration_number_1"
                            label="Registrska številka"
                            append-icon="mdi-car"
                            readonly
                            filled
                        ></v-text-field>
                        <div style="min-height:10px;"></div>
                        <v-textarea
                        outlined
                        name="input-7-4"
                        label="Opombe"
                        v-model="note"
                        counter
                        required
                        ></v-textarea>
                        <v-switch
                            v-model="registration_numbers_enabled"
                            :label="`Dovoli dostop: ${userRegistrationNumbersEnabled}`"
                            color="secondary"
                            hide-details
                        ></v-switch>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn :disabled="disableSubmit" :loading="loading" color="success" text @click="submitForm()"><v-icon left>mdi-arrow-right</v-icon>Shrani</v-btn>
                        <v-btn color="error" text  @click="cancel()"><v-icon left>mdi-close</v-icon>{{ cancelText }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
import { EventBus } from '@/main.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    name: 'add-user-dialog',
    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({
        valid: true,
        formTitle: "",
        dialog: false,
        item: null,
        loading:false,
        disableSubmit: false,
        cancelText: "Prekliči",
        userTypeInfoText: 'Izberite tip uporabnika',

        restriction_start_date_formatted: null,
        restriction_end_date_formatted: null,
        start_date_menu: false,
        end_date_menu:false,
        user_type: '7f02e280-09e0-48e4-b5d5-c75ddcd3e20b',
        restriction_start_date: null,
        restriction_end_date: null,
        name: null,
        reservation: null,
        room_number: null,
        phone_number_1 : null,
        note: null,
        registration_number_1: null,
        registration_numbers_enabled: true,
        phone_numbers_enabled: true,
        restriction_type_id: null,
        selected_devices: [],
        restrictionTypes: [],
        devices: [],

        phone_number_rules: [v => !!v || 'Polje za vnos telefonske številke je obvezno'],
        reservation_rules: [v => !!v || 'Polje za vnos rezervacije je obvezno'],
        name_rules: [v => !!v || 'Polje za vnos naziva je obvezno'],
        reservation_email: [v => !!v || 'Polje za vnos emaila je obvezno'],

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],
        currentDate: null

    }),

    watch: {
        restriction_start_date (val) {
            this.restriction_start_date_formatted = formatDate(val)
        },

        restriction_end_date (val) {
            this.restriction_end_date_formatted = formatDate(val)
        },

        registration_number_1(value) {
            if(value != null) {
                //window.console.log(this.registration_number_1)
                this.registration_number_1 = this.registration_number_1.replace(/[^a-zA-Z0-9]/g, "");
                this.registration_number_1 = this.registration_number_1.toUpperCase();
            }
        },

        user_type(value) {
            this.$refs.form.resetValidation();
            this.setDefaultFormValues
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        userRegistrationNumbersEnabled() {
            if(this.registration_numbers_enabled) {
                return 'DA'
            }

            return 'NE'
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        }
    },

    methods: {
        startDateMenuSave(value) {
            this.$refs.start_date_menu.save(value)
            this.start_date_menu = false
        },

        endDateMenuSave(value) {
            this.$refs.end_date_menu.save(value)
            this.end_date_menu = false
        },
        
        submitForm() {
            var vm = this
            //window.console.log(vm.registration_number_1)
            if(this.$refs.form.validate()) {
                vm.loading = true
                vm.backendValidationMessages = []
                vm.backendMessages = []
                vm.backendErrorMessages = []

                vm.$store.dispatch('CREATE_RFID_USER', {
                    name: vm.name,
                    registration_number_1: vm.registration_number_1,
                    registration_numbers_enabled: (vm.registration_numbers_enabled) ? true : false,
                    phone_numbers_enabled: vm.phone_numbers_enabled,
                    restriction_start_date: vm.restriction_start_date,
                    restriction_end_date: vm.restriction_end_date,
                    note: vm.note,
                    restriction_id: vm.restriction_id,
                    selected_devices: this.selected_devices.map(item => item.id)
                })
                .then(response => {
                    //window.console.log(response)
                    vm.backendMessages.push('Uporabnik je bil uspešno vnesen v sistem.');
                    vm.disableSubmit = true
                    vm.cancelText = "Zaključi"

                })
                .catch(error => {
                    console.log('CREATE RFID USER error')
                    console.log(error)

                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... pri zapisovanju uporabnika je prišlo do napake. Poskusite ponovno.')
                    }

                })
                .finally(() => {
                    setTimeout(() =>{
                        vm.loading = false
                    },600)
                })
            }
        },

        cancel() {
            this.clearForm()
            this.item = null
            this.dialog = false
            EventBus.$emit('refresh_dt_events', null)
        },

        clearForm() {
            this.$refs.form.resetValidation();
            this.setDefaultFormValues()
            this.clearBackendMessages()
        },

        setDefaultFormValues() {
            this.restriction_start_date = this.currentDate
            this.restriction_end_date = this.currentDate
            this.name = null
            this.phone_number_1 = null
            this.note = null
            this.registration_numbers_enabled = true
            this.phone_numbers_enabled = true
            this.restriction_type_id = null
            this.selected_devices = []
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },

        setFormTitle() {
            //window.console.log(this.item)
            //window.console.log(this.item.registration_plate_number)
            if(this.item != null && this.item != undefined) {
                if(this.item.device.entrance == 1) {
                   if(this.item.registration_plate_number != null) {
                       this.formTitle = 'Vhod: ' + this.item.registration_plate_number.toUpperCase() + " - " + this.item.event_timestamp
                   }

                   if(this.item.phone_number != null) {
                       this.formTitle = 'Vhod: ' + this.item.phone_number + " - " + this.item.event_timestamp
                   }
                   
                }

                if(this.item.registration_plate_number != null) {
                    this.formTitle = 'Izhod: ' + this.item.registration_plate_number.toUpperCase() + " - " + this.item.event_timestamp
                }

                if(this.item.phone_number != null) {
                    this.formTitle = 'Izhod: ' + this.item.phone_number + " - " + this.item.event_timestamp
                }
            }
        }
    },

    created() {
        var vm = this;
        this.currentDate = getCurrentDate()

        this.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //console.log(response.data)
            this.restrictionTypes = response.data.restrictionTypes
            this.devices = response.data.devices
        })
        .catch(error => {
            console.log("error")
            console.log(error)
        })

        EventBus.$on('ADD_USER_DIALOG', function(data) {
            vm.item = data
            vm.registration_number_1 = data.registration_plate_number
            vm.phone_number_1 = data.phone_number
            vm.setFormTitle();
            vm.dialog = true;
        });
    },

    mounted() {
        this.restriction_start_date = this.currentDate
        this.restriction_end_date = this.currentDate
    },

    destroyed() {
        //EventBus.$off('ADD_USER_DIALOG')
    }
}

</script>

<style scoped>

</style>